export default __webpack_public_path__ + "05ec357393dae2eb0a36401234300bff.png";